import { SnackbarProvider } from "notistack";
import HelpCenterManager from "./HelpCenterManager/HelpCenterManager";
import LoaderManager from "./LoaderManager/LoaderManager";
import SnackbarManager from "./SnackbarManager/SnackbarManager";
import { ScopedCssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import Theme from "../themes/newco";
import ModalManager from "./ModalManager/ModalManager";
import EventManager from "./EventManager/EventManager";
import { FRAME_EVENT } from "./consts/Frame";
import FeatureService from "../svc/FeatureService";
import { useEffect } from "react";
import "./Overlay.scss";
import RefreshLogoutManager from "./RefreshLogoutManager/RefreshLogoutManager";
import ProgressBarManager from "./ProgressBarManager/ProgressBarManager";
import { ErrorBoundary } from "react-error-boundary";
import { FallbackError } from "../common/components/molecules/FallbackError";

const eventManager = EventManager.getInstance();

export default function OverlayManager() {
    useEffect(() => {
        const unsubscribe = eventManager.subscribe((type, data) => {
            // Sync Feature Ctx
            if (type === FRAME_EVENT.FEATURE_CTX_SYNC) {
                FeatureService.initialize(data);
            } else if (type === FRAME_EVENT.NAVIGATE_TO_URL) {
                window.location.href = data?.auth_url;
            }
        });

        return unsubscribe;
    }, []);

    return (
        <ScopedCssBaseline
            sx={{
                fontFamily: "'Inter' !important",
            }}
        >
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={Theme}>
                    <SnackbarProvider
                        autoHideDuration={15000}
                        disableWindowBlurListener={true}
                    >
                        <ErrorBoundary fallback={<FallbackError />}>
                            <SnackbarManager />
                            <LoaderManager />
                            <ProgressBarManager />
                            <ModalManager />
                            <HelpCenterManager />
                            <RefreshLogoutManager />
                        </ErrorBoundary>
                    </SnackbarProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </ScopedCssBaseline>
    );
}
